import type { ReactNode, RefObject } from "react";

import { Fragment, useEffect } from "react";

import clsx from "clsx";
import { TableBody as AriaTableBody } from "react-aria-components";

import styles from "./table-body.module.css";

const LOADING_ITEMS = ["0", "1", "2", "3", "4", "5", "6"];

type TableBodyProps<T extends { id: string }> = {
	bodyRef: RefObject<HTMLTableSectionElement | null>;
	data: T[];
	isLoading: boolean;
	isScrollbarVisible: boolean;
	row: (item: T) => ReactNode;
};

export function TableBody<T extends { id: string }>({
	bodyRef,
	data,
	isLoading,
	isScrollbarVisible,
	row,
}: TableBodyProps<T>): ReactNode {
	// Scroll to top when we change page
	useEffect(() => {
		bodyRef.current?.scrollTo({ top: 0 });
	}, [data, bodyRef]);

	return (
		<AriaTableBody
			className={clsx(styles.body, isScrollbarVisible && styles.bodyScrollbarVisible)}
			ref={bodyRef}
		>
			{isLoading
				? LOADING_ITEMS.map((id) => {
						return <Fragment key={id}>{row({ id } as T)}</Fragment>;
					})
				: data.map((item) => {
						return <Fragment key={item.id}>{row(item)}</Fragment>;
					})}
		</AriaTableBody>
	);
}
